import { EpimsBaseEntityDto } from './epim-base.dto';

import { IsNotEmpty } from 'class-validator';

export class ScholarshipTypeDto extends EpimsBaseEntityDto {
	@IsNotEmpty() ScholarshipTypeId: string;
	@IsNotEmpty() ScholarshipTypeName: string;
  @IsNotEmpty() SubscriberId: string;
                ScholarshipCategoryId
}
